import Styles from './CardInfo.styles';

export const CardInfoSkeleton = () => {
  return (
    <Styles.Wrapper>
      {[...Array(4)].map((_, index) => (
        <Styles.CardSkeleton key={`card-${index}`} />
      ))}
    </Styles.Wrapper>
  );
};
